import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useMatchingUnavailableReasonsQuery(
	dealGuid?: Guid | undefined,
	structureTranche?: number | null,
	tier1BankType?: number | null,
	options?: Omit<UseQueryOptions<string[], unknown, string[], any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Matching.UnavailableReasons(dealGuid, structureTranche, tier1BankType),
		() =>
			AxiosUtils.getResponseData<string[]>(
				api.get(CerebroApiEndpoints.Matching.UnavailableReasons(dealGuid, structureTranche, tier1BankType))
			),
		options
	);
}
